import React, { useState } from "react";
import LeftNav from "../../components/leftNav/LeftNav";
import TopNav from "../../components/topNav/TopNav";
import { Link } from "react-router";

type EstadoViatico = "Pendiente" | "Aprobado" | "Devuelto";

interface Viatico {
  id: number;
  monto: number;
  kilometros: number;
  destino: string;
  fecha: string;
  estado: EstadoViatico;
}

const Viaticos: React.FC = () => {
  const [viaticos] = useState<Viatico[]>([
    {
      id: 1,
      monto: 500,
      kilometros: 120,
      destino: "San José",
      fecha: "2025-10-01",
      estado: "Pendiente",
    },
    {
      id: 2,
      monto: 800,
      kilometros: 250,
      destino: "Alajuela",
      fecha: "2025-10-02",
      estado: "Aprobado",
    },
    {
      id: 3,
      monto: 300,
      kilometros: 60,
      destino: "Cartago",
      fecha: "2025-10-03",
      estado: "Devuelto",
    },
  ]);

  const [search, setSearch] = useState("");
  const [filtroFecha, setFiltroFecha] = useState("");

  const viaticosFiltrados = viaticos.filter(
    (v) =>
      (v.destino.toLowerCase().includes(search.toLowerCase()) ||
        v.id.toString().includes(search)) &&
      (filtroFecha ? v.fecha === filtroFecha : true)
  );

  return (
    <div className="flex h-screen bg-gray-100">
      <LeftNav />

      <div className="flex flex-1 flex-col">
        <TopNav />

        <main className="flex-1 overflow-y-auto p-6">
          <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
            <div className="flex flex-wrap jus gap-4">
              <label className="flex flex-col text-sm text-gray-700">
                Fecha
                <input
                  type="date"
                  value={filtroFecha}
                  onChange={(e) => setFiltroFecha(e.target.value)}
                  className="mt-1 rounded-lg border border-gray-300 px-3 py-2 text-sm"
                />
              </label>

              <label className="flex flex-col text-sm text-gray-700">
                Buscar
                <input
                  type="text"
                  placeholder="Destino o # viático"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  className="mt-1 rounded-lg border border-gray-300 px-3 py-2 text-sm"
                />
              </label>
            </div>
            <div>
              <Link
                to="/viaticos/new"
                className="rounded-lg bg-blue-600 px-4 py-2 text-white hover:bg-blue-700"
              >
                Nuevo Viático
              </Link>
            </div>
          </div>

          <div className="overflow-x-auto rounded-lg shadow">
            <table className="w-full border-collapse bg-white text-sm">
              <thead>
                <tr className="bg-gray-100 text-left text-gray-600">
                  <th className="px-4 py-3">#</th>
                  <th className="px-4 py-3">Destino</th>
                  <th className="px-4 py-3">Fecha</th>
                  <th className="px-4 py-3">Kilómetros</th>
                  <th className="px-4 py-3">Monto</th>
                  <th className="px-4 py-3">Estado</th>
                  <th className="px-4 py-3">Acciones</th>
                </tr>
              </thead>
              <tbody>
                {viaticosFiltrados.map((v) => (
                  <tr key={v.id} className="border-t hover:bg-gray-50">
                    <td className="px-4 py-3">{v.id}</td>
                    <td className="px-4 py-3">{v.destino}</td>
                    <td className="px-4 py-3">{v.fecha}</td>
                    <td className="px-4 py-3">{v.kilometros} km</td>
                    <td className="px-4 py-3 font-medium text-blue-600">
                      ₡{v.monto}
                    </td>
                    <td className="px-4 py-3">
                      <span
                        className={`rounded-full px-3 py-1 text-xs font-semibold ${
                          v.estado === "Pendiente"
                            ? "bg-yellow-100 text-yellow-700"
                            : v.estado === "Aprobado"
                            ? "bg-green-100 text-green-700"
                            : "bg-red-100 text-red-700"
                        }`}
                      >
                        {v.estado}
                      </span>
                    </td>
                    <td className="px-4 py-3">
                      <Link
                        to={`/viaticos/${v.id}`}
                        className="rounded-lg bg-gray-500 px-4 py-2 text-white hover:bg-gray-600"
                      >
                        Ver
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </main>
      </div>
    </div>
  );
};

export default Viaticos;
